<template>
  <div>
    <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Brands', to: '/brands' },
      { label: 'Edit' }
    ]" title="Edit Brands" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4">
      <div class="w-1/2">
        <form @submit.prevent="onSubmit">
          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Brand Name
            </label>
            <input id="name" type="text" v-model="form.name" placeholder="Enter Brand Name" :class="[
      'w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2',
      isNameExist ? 'bg-red-custom focus:ring-red-500' : 'border-gray-300 '
    ]" />
          </div>
          <div class="mb-3 flex justify-between">
            <div class="flex-col w-full">
              <div class="grid grid-cols-2 gap-4 pr-2">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                    Brand Code
                  </label>
                  <input id="brand_code" type="text" v-model="form.brand_code" placeholder="Enter Brand Code" :class="[
      'w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2',
      isNameExist ? 'bg-red-custom focus:ring-red-500' : 'border-gray-300 '
    ]" />
                </div>
                <div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Publisher
                    </label>
                    <multiselect
                    id="vendor"
                    v-model="form.vendor_id"
                    label="name"
                    track-by="name"
                    placeholder="Select Publisher"
                    open-direction="bottom"
                    :options="vendorSearchOptions"
                    :searchable="true"
                    :loading="isVendorSearch"
                    :close-on-select="true"
                    @search-change="getVendorFind"
                    class="custom-multiselect"
                   :class="{ 'error': submitted && !form.vendor_id }"
                  >
                    <template #noResult>
                      <span class="text-sm text-gray-500 px-2 py-1">No publisher found.</span>
                    </template>
                  </multiselect>

                  <p v-if="submitted && !form.vendor_id" class="text-red-500 text-sm mt-1">Must be filled.</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3 flex justify-between">
            <div class="flex-col w-full">
              <div class="grid grid-cols-3 gap-4 pr-0">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Default Contents Type
                  </label>
                  <TypeContent v-model="form.default_item_type" :options="defaultItemTypeOption"
                      :defaultText="'Select Default Contents Type'" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Default Contents Schedule
                  </label>
                  <TypeContent v-model="form.default_item_schedule" :options="defaultBrandTypeOption"
                      :defaultText="'Select Default Contents Schedule'" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Release Period
                  </label>
                  <TypeContent v-model="form.release_period" :options="defaultReleasePeriodOption"
                      :defaultText="'Select Release Period'" />
                   
                  </div>
              </div>
            </div>
          </div>
          <div class="mb-3 mr-2">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Default Languages
            </label>
            <multiselect placeholder="Enter languages" open-direction="bottom" v-model="form.default_languages"
                      label="name" track-by="name" :custom-label="nameWithISO" :options="languagesSearchOptions"
                      :searchable="true" :close-on-select="true" :options-limit="10" :multiple="true" required>
                    </multiselect>
          </div>
          <div class="mb-3 mr-2">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Default Countries
            </label>
            <multiselect placeholder="Enter Countries" open-direction="bottom" v-model="form.default_countries"
                      label="iso" track-by="iso" :custom-label="nameWithISO" :options="countriesSearchOptions"
                      :loading="isCountriesSearch" :searchable="true" :close-on-select="true" :options-limit="10"
                      :multiple="true">
                    </multiselect>
          </div>
          <div class="mb-3 mr-0">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Description (Optional)
            </label>
            <t-textarea type="number" class="rounded-lg mb-4" placeholder="Enter description about brand..."
            v-model="form.description" ></t-textarea>
          </div>
          <div class="mb-3 mr-0">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Status
            </label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.is_active,
                  'bg-gray-300': !form.is_active
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.is_active,
                  'translate-x-0': !form.is_active
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
          </div>   
          <div class="mb-3 mr-0 flex justify-start">
            <button  type='submit' class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
            <button  type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
              <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm" :to="{ path: '/brands' }">
               Cancel
            </router-link>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { EditBrandPath } from '../../router/clients';
import constant from "../../store/constant";
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import TypeContent from '@/components/form/ContentTypeSelector'
import {EventBus} from '../../event-bus'

export default {
  name: 'editBrands',
  components: {
    HeaderBreadcrumbs,
    TypeContent,
  },

  data() {
    return {
      EditBrandPath,
      debounce: null,
      isNameExist:false,
      submitted: false,
      id: null,
      form: {
        id:null,
        name:null,
        brand_code:null,
        default_item_type:null,
        default_item_schedule:null,
        vendor_id:null,
        release_period:null,
        description:null,
        default_countries:[],
        default_languages:[],
        sort_priority:null,
        is_active: false,
      },
      isCountriesSearch: false,
      isVendorSearch:false,
      defaultItemTypeOption: [
				{ value: constant.ITEM_TYPES.MAGAZINE.toLowerCase(), text: "Magazine" },
        { value: constant.ITEM_TYPES.BOOK.toLowerCase(), text: "Book" },
        { value: constant.ITEM_TYPES.NEWSPAPER.toLowerCase(), text: "Newspaper" },
        { value: constant.ITEM_TYPES.AUDIOBOOK.toLowerCase(), text: "Audiobook" },
      ],
      defaultBrandTypeOption:[
        { value: constant.BRAND_TYPE.EDITION, text: "Edition" },
        { value: constant.BRAND_TYPE.MONTHLY, text: "Monthly" },
      ],
      defaultReleasePeriodOption:[
        { value: constant.BRAND_RELEASE_PERIOD.DAILY, text: "Daily" },
        { value: constant.BRAND_RELEASE_PERIOD.WEEKLY, text: "Weekly" },
        { value: constant.BRAND_RELEASE_PERIOD.BIWEEKLY, text: "Bi-Weekly" },
        { value: constant.BRAND_RELEASE_PERIOD.MONTHLY, text: "Monthly" },
        { value: constant.BRAND_RELEASE_PERIOD.BIMONTHLY, text: "Bi-Monthly" },
        { value: constant.BRAND_RELEASE_PERIOD.QUARTERLY, text: "Quaterly" },
        { value: constant.BRAND_RELEASE_PERIOD.SPECIAL, text: "Special" },
      ],
      countriesSearchOptions: [],
      vendorSearchOptions:[],
      languagesSearchOptions: [],
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.brands.totalRows,
      items :(state) => state.brands.items,
      isLoading : (state) => state.brands.isLoading,
      isSuccess : (state) => state.brands.isSuccess,
      successMessage: (state) => state.brands.successMessage,
      errorMessage:(state) => state.brands.errorMessage,
      refresh: (state) => state.brands.refresh,
    }),
  },
  watch: {
    successMessage: function () {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
            message:'Brand has been updated.',
            type: 'success',
          });
      this.$router.push({
        path: `/brands`,
      })
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    items: function () {
      if(!this.items){
        return this.baseAlert({
          icon:'error',
          title: 'Error',
          text: 'No Items Avaiable',
        });
      }
      this.setEditBrands();    
    }
  },
  created() {
    this.setCountriesOptions();
    this.languagesSearchOptions = Object.entries(constant.LANGUAGE_CHOICES).map((items) => { 
      return {
        iso: items[0].toUpperCase(),
        name: items[0]
      } 
    });
    this.actionGetBrands();
  },
  mounted() {
    this.actionGetBrands();
  },
  methods: {
  ...mapActions("brands", ["searchVendorById","searchVendor","getCountries","fetchBrandsByid","updateBrands"]),
    actionGetBrands() {
      let id=this.$route.params.id;
      this.id = this.$route.params.id;
      let payload = {
        id,
      };
      this.fetchBrandsByid(payload);
    },
  onSubmit(event) {
		event.preventDefault();
    this.submitted = true;
      if (!this.form.vendor_id) return; 
		const data = this.form;
    const payload = {
      id: this.id,
      name: data.name,
      brand_code: data.brand_code,
      vendor_id:data.vendor_id.id,
      default_item_type:data.default_item_type,
      default_item_schedule:data.default_item_schedule,
      release_period:data.release_period,
      description:data.description,
      default_languages: data.default_languages.map(item => item.iso.toLowerCase()),
      default_countries: data.default_countries.map(item=>item.iso.toLowerCase()),
      is_active:data.is_active,
    }
    this.updateBrands(payload);
    
	},onReset() {

  },setCountriesOptions() {
      this.isCountriesSearch = true;
      this.getCountries()
      .then((response) => {
        this.countriesSearchOptions = response.data.data.rows;
        this.isCountriesSearch = false;
      })
      .catch(() => {
        this.isCountriesSearch = false;
      });
  },getVendorFind(query){
      this.isVendorSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchVendor({ q: query }).then((response) => {
          this.vendorSearchOptions = response.data.data.rows;});
        this.isVendorSearch = false;
      }, 600);
  },messageAlert(icon, title, timer = 3000) {
      this.$swal({
        toast: 'true',
        position: 'top-end',
        icon,
        title,
        showConfirmButton: false,
        timer,
        timerProgressBar: true,
      });
  },nameWithISO({ name, iso }) {
      return `${iso} - ${name}`
  },setEditBrands() {
      const data = this.items;
      this.form.name = data.name;
      this.form.brand_code = data.brand_code;
      if(data.vendor_id){
        this.searchVendorById(data.vendor_id).then(response => {
        this.form.vendor_id = response.data?.data?.rows[0];
        this.vendorSearchOptions = response.data?.data?.rows;
      }); 
      }
      this.form.description=data.description;
      this.form.default_item_type = data.default_item_type;
      this.form.default_item_schedule = data.default_item_schedule;
      this.form.release_period= data.release_period;
      if(data.default_languages){
        this.form.default_languages = this.languagesSearchOptions
        .filter(
          items => [...data.default_languages].includes(items.iso.toLowerCase())
      );
      }
      if(data.default_countries){
        this.form.default_countries = this.countriesSearchOptions
        .filter(
          items => [...data.default_countries].includes(items.iso.toLowerCase())
      );
      }
      this.form.description = data.description;
      this.form.is_active=data.is_active;
    },
    toggleActive() {
      this.form.is_active = !this.form.is_active;
    },
    baseAlert(data) {
        this.$swal({
          icon: data.icon,
          title: data.title,
          text: data.text,
        })
    },
  }
  
};

</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>